import React, { useState } from 'react';
import HorryCountyLogo from './HorryCountyLogo';
import { BASE_URL } from '../constants';
import { Menu } from 'react-feather';

const TopBar: React.FC = () => {
  const [isActive, setIsActive] = useState<boolean>(false)

  return (
    <header>
      <div>
        <HorryCountyLogo />
        <h1>
          <span>GIS </span>
          <strong>Parcel Application</strong>
        </h1>
      </div>
      <nav>
        <Menu onClick={() => setIsActive(!isActive)} />
        <div className={`nav${isActive ? ' active' : ''}`}>
          <a href={`${BASE_URL}/disclaimer/`}>Disclaimer</a>
        </div>
      </nav>
    </header>
  )
}

export default TopBar;